import { render, staticRenderFns } from "./UpgradePlansV2.vue?vue&type=template&id=48ce1876"
import script from "./UpgradePlansV2.vue?vue&type=script&lang=js"
export * from "./UpgradePlansV2.vue?vue&type=script&lang=js"
import style0 from "./UpgradePlansV2.vue?vue&type=style&index=0&id=48ce1876&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports